import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiUpload } from "react-icons/fi";
import Search from "../../components/Search";
import ClassActivityHeader from "../../components/pages/classActivity/classActivityHeader";
import AllAssignment from "../../components/pages/classActivity/allAssignment";
import ClassActivityBtn from "../../components/pages/classActivity/ClassActivityBtn";

export default function ClassroomActivity() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openSuccessfulDeleteModal, setOpenSuccessfulDeleteModal] =
    useState(false);
  const [classroom, setClassroom] = useState("");
  const [description, setDescription] = useState("");
  const [members, setMembers] = useState(["Tom Browns", "Tom Browns"]);
  const [editModal, setEditModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const navigateToAssignment = () => {
    navigate("/classroom/AssignmentView");
  };

  const navigateToAddAssignment = () => {
    navigate("/classroom/AddAssignment");
  };

  const handleDeleteSubject = () => {
    setOpenDeleteModal(true);
  };

  const cancelModal = () => setOpenDeleteModal(false);

  const confirmDelete = () => {
    setOpenDeleteModal(false);
    setOpenSuccessfulDeleteModal(true);
  };

  const closeSuccessfulDeleteModal = () => {
    setOpenSuccessfulDeleteModal(false);
  };

  const handleUpdate = () => {
    setEditModal(false);
    setSuccessModal(true);
  };

  const closeSuccessModal = () => {
    setSuccessModal(false);
  };

  const assignments = [
    {
      img: "../assets/course_2.png",
      subtitle: "Assignment #1",
      title: "Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Proin libero morbi nulla morbi urna mauris volutpat sed lobortis. Quis purus lacinia te",
    },
    {
      img: "../assets/course_2.png",
      subtitle: "Assignment #1",
      title: "Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Proin libero morbi nulla morbi urna mauris volutpat sed lobortis. Quis purus lacinia te",
    },
    {
      img: "../assets/course_2.png",
      subtitle: "Assignment #1",
      title: "Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Proin libero morbi nulla morbi urna mauris volutpat sed lobortis. Quis purus lacinia te",
    },
  ];

  return (
    <div className="p-6 bg-white rounded-lg shadow-md m-3">
      <ClassActivityHeader onSearch={handleSearch} />
      <AllAssignment
        assignments={assignments}
        navigateToAssignment={navigateToAssignment}
        navigateToAddAssignment={navigateToAddAssignment}
      />
      <ClassActivityBtn
        setEditModal={setEditModal}
        handleDeleteSubject={handleDeleteSubject}
        openDeleteModal={openDeleteModal}
        cancelModal={cancelModal}
        confirmDelete={confirmDelete}
        openSuccessfulDeleteModal={openSuccessfulDeleteModal}
        closeSuccessfulDeleteModal={closeSuccessfulDeleteModal}
        editModal={editModal}
        classroom={classroom}
        setClassroom={setClassroom}
        description={description}
        setDescription={setDescription}
        members={members}
        setMembers={setMembers}
        handleUpdate={handleUpdate}
        successModal={successModal}
        closeSuccessModal={closeSuccessModal}
      />
    </div>
  );
}
